import React, { Children } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
export const PrivacyPage = () => {
  return <section className="w-full bg-white py-16" data-id="element-105">
      <div className="max-w-4xl mx-auto px-4" data-id="element-106">
        <Link to="/" className="inline-flex items-center text-emerald-600 hover:text-emerald-700 mb-8" data-id="element-107">
          <ArrowLeft className="h-4 w-4 mr-2" data-id="element-108" />
          Back to Home
        </Link>
        <article className="prose prose-lg max-w-none" data-id="element-109">
          <h1 className="text-3xl font-bold text-center text-gray-900 mb-4" data-id="element-110">
            EndorseHive Privacy Policy
          </h1>
          <p className="text-gray-600 italic text-center mb-12" data-id="element-111">
            Effective Date: 1 February 2025
          </p>
          <div className="space-y-12" data-id="element-112">
            {/* 1. Introduction */}
            <section data-id="element-113">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-114">
                1. Introduction
              </h2>
              <div className="space-y-6" data-id="element-115">
                <div data-id="element-116">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-117">
                    1.1 Who We Are
                  </h3>
                  <p className="text-gray-600" data-id="element-118">
                    This Privacy Policy ("Policy") explains how LeanOps LLC
                    (d/b/a "EndorseHive"), located at{" "}
                    <em data-id="element-119">16192 Coastal Hwy, Lewes, Delaware 19958</em>, collects,
                    uses, stores, and discloses your personal information.
                  </p>
                </div>
                <div data-id="element-120">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-121">
                    1.2 Contact Information
                  </h3>
                  <p className="text-gray-600" data-id="element-122">
                    If you have any questions or concerns about this Policy or
                    our data practices, you can reach us at:
                  </p>
                  <p className="text-gray-600" data-id="element-123">
                    Email:{" "}
                    <a href="mailto:privacy@endorsehive.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-124">
                      privacy@endorsehive.com
                    </a>
                  </p>
                  <p className="text-gray-600 mt-4" data-id="element-125">
                    By using our services ("Service") or interacting with our
                    website, you agree to the data practices described in this
                    Policy.
                  </p>
                </div>
              </div>
            </section>
            {/* 2. Information We Collect */}
            <section data-id="element-126">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-127">
                2. Information We Collect
              </h2>
              <div className="space-y-6" data-id="element-128">
                <div data-id="element-129">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-130">
                    2.1 LinkedIn Account Credentials
                  </h3>
                  <p className="text-gray-600" data-id="element-131">
                    Username and Password: We collect your LinkedIn username and
                    password if you join our micro-influencer program and grant
                    us access to post content, add connections, and message on
                    your behalf.
                  </p>
                </div>
                <div data-id="element-132">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-133">
                    2.2 User Profile Data
                  </h3>
                  <p className="text-gray-600" data-id="element-134">
                    Name and Email Address: We may collect your full name and
                    email address when you sign up or communicate with us.
                  </p>
                </div>
                <div data-id="element-135">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-136">
                    2.3 Website Analytics & Cookies
                  </h3>
                  <p className="text-gray-600" data-id="element-137">
                    We use standard website tracking and analytics tools (e.g.,
                    Google Analytics, Facebook, Instagram, LinkedIn pixels,
                    Hotjar) on our site. These tools may collect information
                    such as IP address, browser type, referring URLs, and pages
                    visited.
                  </p>
                  <p className="text-gray-600 mt-2" data-id="element-138">
                    Cookies: We use "normal" (first-party) cookies for essential
                    functionality and to understand how users interact with our
                    site. We do not currently provide an opt-in/opt-out cookie
                    mechanism but may do so in the future.
                  </p>
                </div>
              </div>
            </section>
            {/* 3. How We Use Your Information */}
            <section data-id="element-139">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-140">
                3. How We Use Your Information
              </h2>
              <div className="space-y-6" data-id="element-141">
                <div data-id="element-142">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-143">
                    3.1 For Business Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-144">
                    We use your information to provide our services, improve our
                    products and services, and to personalize your experience on
                    our website.
                  </p>
                </div>
                <div data-id="element-145">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-146">
                    3.2 For Marketing Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-147">
                    We may use your information to send you marketing
                    communications, such as newsletters, promotional offers, and
                    updates about our products and services.
                  </p>
                </div>
                <div data-id="element-148">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-149">
                    3.3 For Compliance and Legal Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-150">
                    We may use your information to comply with legal
                    requirements and to protect our rights and interests.
                  </p>
                </div>
              </div>
            </section>
            {/* 4. Sharing Your Information */}
            <section data-id="element-151">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-152">
                4. Sharing Your Information
              </h2>
              <div className="space-y-6" data-id="element-153">
                <div data-id="element-154">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-155">
                    4.1 With Third Parties
                  </h3>
                  <p className="text-gray-600" data-id="element-156">
                    We may share your information with third parties, such as
                    service providers, advertisers, and analytics partners, for
                    the purposes described in this Policy.
                  </p>
                </div>
                <div data-id="element-157">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-158">
                    4.2 With Your Consent
                  </h3>
                  <p className="text-gray-600" data-id="element-159">
                    We may share your information with third parties with your
                    consent, provided that we have obtained your prior consent.
                  </p>
                </div>
              </div>
            </section>
            {/* 5. Data Retention */}
            <section data-id="element-160">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-161">
                5. Data Retention
              </h2>
              <div className="space-y-6" data-id="element-162">
                <div data-id="element-163">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-164">
                    5.1 For Business Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-165">
                    We retain your information for as long as necessary to
                    provide our services and to comply with legal requirements.
                  </p>
                </div>
                <div data-id="element-166">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-167">
                    5.2 For Marketing Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-168">
                    We retain your information for as long as necessary to send
                    you marketing communications.
                  </p>
                </div>
                <div data-id="element-169">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-170">
                    5.3 For Compliance and Legal Purposes
                  </h3>
                  <p className="text-gray-600" data-id="element-171">
                    We retain your information for as long as necessary to
                    comply with legal requirements.
                  </p>
                </div>
              </div>
            </section>
            {/* 6. Security */}
            <section data-id="element-172">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-173">
                6. Security
              </h2>
              <div className="space-y-6" data-id="element-174">
                <div data-id="element-175">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-176">
                    6.1 Data Encryption
                  </h3>
                  <p className="text-gray-600" data-id="element-177">
                    We use industry-standard encryption to protect your
                    information during transmission and storage.
                  </p>
                </div>
                <div data-id="element-178">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-179">
                    6.2 Access Controls
                  </h3>
                  <p className="text-gray-600" data-id="element-180">
                    We have strict access controls in place to protect your
                    information from unauthorized access, use, or disclosure.
                  </p>
                </div>
                <div data-id="element-181">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-182">
                    6.3 Security Breach Notification
                  </h3>
                  <p className="text-gray-600" data-id="element-183">
                    If we become aware of a security breach that may affect your
                    information, we will notify you as soon as possible.
                  </p>
                </div>
              </div>
            </section>
            {/* 7. Your Rights */}
            <section data-id="element-184">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-185">
                7. Your Rights
              </h2>
              <div className="space-y-6" data-id="element-186">
                <div data-id="element-187">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-188">
                    7.1 Access to Your Information
                  </h3>
                  <p className="text-gray-600" data-id="element-189">
                    You have the right to access your personal information that
                    we hold about you.
                  </p>
                </div>
                <div data-id="element-190">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-191">
                    7.2 Correction of Your Information
                  </h3>
                  <p className="text-gray-600" data-id="element-192">
                    You have the right to request that we correct any
                    inaccuracies in your personal information that we hold about
                    you.
                  </p>
                </div>
                <div data-id="element-193">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-194">
                    7.3 Deletion of Your Information
                  </h3>
                  <p className="text-gray-600" data-id="element-195">
                    You have the right to request that we delete your personal
                    information that we hold about you.
                  </p>
                </div>
                <div data-id="element-196">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-197">
                    7.4 Opt-Out of Marketing Communications
                  </h3>
                  <p className="text-gray-600" data-id="element-198">
                    You have the right to opt-out of receiving marketing
                    communications from us.
                  </p>
                </div>
              </div>
            </section>
            {/* 8. Cookies */}
            <section data-id="element-199">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-200">
                8. Cookies
              </h2>
              <div className="space-y-6" data-id="element-201">
                <div data-id="element-202">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-203">
                    8.1 What Are Cookies?
                  </h3>
                  <p className="text-gray-600" data-id="element-204">
                    Cookies are small text files that are stored on your device
                    when you visit a website.
                  </p>
                </div>
                <div data-id="element-205">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-206">
                    8.2 How We Use Cookies
                  </h3>
                  <p className="text-gray-600" data-id="element-207">
                    We use cookies to provide essential functionality and to
                    understand how users interact with our site.
                  </p>
                </div>
                <div data-id="element-208">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-209">
                    8.3 Opt-Out of Cookies
                  </h3>
                  <p className="text-gray-600" data-id="element-210">
                    You can opt-out of cookies by adjusting your browser
                    settings.
                  </p>
                </div>
              </div>
            </section>
            {/* 9. Third-Party Links */}
            <section data-id="element-211">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-212">
                9. Third-Party Links
              </h2>
              <div className="space-y-6" data-id="element-213">
                <div data-id="element-214">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-215">
                    9.1 Links to Third-Party Websites
                  </h3>
                  <p className="text-gray-600" data-id="element-216">
                    Our website may contain links to third-party websites that
                    are not owned or controlled by us.
                  </p>
                </div>
                <div data-id="element-217">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-218">
                    9.2 Privacy Policies of Third-Party Websites
                  </h3>
                  <p className="text-gray-600" data-id="element-219">
                    We are not responsible for the privacy practices of
                    third-party websites that are linked to our website.
                  </p>
                </div>
              </div>
            </section>
            {/* 10. Children's Privacy */}
            <section data-id="element-220">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-221">
                10. Children's Privacy
              </h2>
              <div className="space-y-6" data-id="element-222">
                <div data-id="element-223">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-224">
                    10.1 We Do Not Collect Personal Information from Children
                  </h3>
                  <p className="text-gray-600" data-id="element-225">
                    We do not collect personal information from children under
                    the age of 13.
                  </p>
                </div>
                <div data-id="element-226">
                  <h3 className="font-bold text-gray-900 mb-2" data-id="element-227">
                    10.2 We Do Not Target Children with Our Services
                  </h3>
                  <p className="text-gray-600" data-id="element-228">
                    We do not target children with our services.
                  </p>
                </div>
              </div>
            </section>
            {/* 11. Contact Us */}
            <section data-id="element-229">
              <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-230">
                11. Contact Us
              </h2>
              <p className="text-gray-600" data-id="element-231">
                If you have any questions or concerns about this Privacy Policy,
                please email us at:{" "}
                <a href="mailto:privacy@endorsehive.com" className="text-emerald-600 hover:text-emerald-700" data-id="element-232">
                  privacy@endorsehive.com
                </a>
              </p>
            </section>
            {/* Disclaimer */}
            <div className="mt-12 p-6 bg-gray-50 rounded-lg border border-gray-200" data-id="element-233">
              <p className="text-gray-600" data-id="element-234">
                <strong data-id="element-235">Disclaimer:</strong> This Privacy Policy is provided for
                informational purposes only and does <em data-id="element-236">not</em> constitute
                legal advice. You should consult legal counsel to ensure that
                this Policy meets all applicable laws and regulations for your
                business.
              </p>
            </div>
          </div>
        </article>
      </div>
    </section>;
};